<template>
  <div class="settings">
    <!--<Breadcrumbs :items="breadcrumbs"/>-->

    <rp-email-form class="password-reset-form"
      @submit="submit"
      v-model="form"/>

    <rp-overlay :active="active">
      <rp-alert
        icon="done"
        :message="successMessage"
        :onClick="successFunction">
      </rp-alert>
    </rp-overlay>
  </div>
</template>

<script>
import {paswordResetUpdateEmail} from 'raypro_ui/src/api/users'

import Email from 'raypro_ui/src/components/ui/forms/ForgotPasswordFormEmail'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'

import page from '@/mixins/page'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  components: {
    'rp-email-form': Email,
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    Breadcrumbs
  },

  data() {
    return {
      form: {email: ''},
      active: false,
      successMessage: 'Please check your email for the instructions.',
      breadcrumbs: [
        {label: 'Reset Password'},
        {label: 'Email'}
      ],
    }
  },

  mixins: [page],

  computed: {
    payload() {
      const user = {email: this.form.email}

      return {data: {user}}
    }
  },
  methods: {
    successFunction() {
      this.$router.push({name: 'Login'})
    },

    submit() {
      paswordResetUpdateEmail(this.payload).then(() => {
        this.active = true
      })
    }
  }
}
</script>

<style lang="sass">
  .password-reset-form
    width: 400px
    border-radius: 20px
    margin: 30px auto 0 auto
    a
      font-weight: bold
</style>



// WEBPACK FOOTER //
// src/components/pages/Password/ForgotPasswordEmail.vue